import type { OptionState } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';
import { toList } from '../../targeting/utils/toList.ts';
import { toMapById } from '../../targeting/utils/toMapById.ts';

export const useDistributionChannelOptionsFetch = (): OptionState => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.rendering_context.distribution_channel',
    },
  });

  const list = useMemo(() => toList(optionsByPath), [optionsByPath]);
  const mapById = useMemo(() => toMapById(list), [list]);

  return useMemo(
    () => ({
      list,
      loading,
      mapById,
      refetch,
    }),
    [list, loading, mapById, refetch]
  );
};
